
const OnBoardingState = {
  SETUP_NEW_ORG: 0,
  SETUP_FIRST_PROJECT: 1,
  INVITE_USER: 2,
  UPLOAD_TEST_RESULT: 3
};

export default OnBoardingState;
